import Tween from "tween.ts";
import Animation from "../../../../../src/animation/Animation";


export default class AngularOscillationAnimation extends Animation {
  private Anim = Animation.getInstance();
  private isStopped: boolean = false;
  private onUpdate!: (a: number) => void;
  private resolve!: () => void;
  constructor(sAngle: number, onUpdate: (a: number) => void, onComp: () => void, resolve: () => void) {
    super();
    const d = 800;
    const angle = Math.PI / 12;

    this.onUpdate = onUpdate;
    this.resolve = resolve;

    this.rootEventBus.on(this.EnumRootEventBus.cancelledCircleAnim, () => this.isStopped = true);

    if(this.Anim.getIsCancelled()) {
        this.resolve();
        return 
    };

    this.moveRedPoint(sAngle, angle, d, () => {
      this.moveRedPoint(sAngle + angle, -angle * 2, d * 2, () => {
        this.moveRedPoint(sAngle - angle, angle, d, () => onComp())
      })
    })
  }

  moveRedPoint(sAngle:number, angle:number, duration:number, onComp: () => void) {
    if(this.Anim.getIsCancelled()) {
      this.resolve();
      return 
    };
    const a = { angle: sAngle };
    new Tween.Tween({ ...a })
      .to({ angle: sAngle + angle }, duration)
      .easing(Tween.Easing.Linear.None)
      .onUpdate((a) => {

        if(this.isStopped) {
          onComp();
          return
        }
        this.onUpdate(a.angle);
      })
      .onComplete(() => onComp())
      .start();
  }
}